export function getTierGradient(tierName?: string): string {
  const name = (tierName || '').toLowerCase();
  if (name === 'bronze') {
    return 'linear-gradient(to right, #D3A575, #B8956A)';
  }
  if (name === 'silver') {
    return 'linear-gradient(to right, #C6C1AF, #B0AB9A)';
  }
  if (name === 'gold') {
    return 'linear-gradient(to right, #FFC200, #E6AE00)';
  }
  return 'linear-gradient(to right, #d1d5db, #9ca3af)';
}

interface TierInfo {
  minPoints?: number;
  maxPoints?: number;
  name?: string;
}

export function getTierProgressWidth(pointsBalance?: number, tier?: TierInfo): number {
  const points = typeof pointsBalance === 'number' ? pointsBalance : 0;
  const max = tier?.maxPoints;
  const min = tier?.minPoints;
  const tierName = (tier?.name || '').toLowerCase();

  // If current tier is Gold, always show full progress
  if (tierName === 'gold') {
    return 100;
  }

  // If tier has a defined max, calculate against it and cap at 100%
  if (typeof max === 'number' && max > 0) {
    const pct = (points / max) * 100;
    return Math.max(0, Math.min(100, pct));
  }

  // For tiers without a max (e.g., top tier), show full progress when meeting min points
  if (typeof min === 'number' && min > 0) {
    if (points >= min) return 100;
    const pct = (points / min) * 100;
    return Math.max(0, Math.min(100, pct));
  }

  // Default when no tier thresholds are available
  return 0;
}
